import {
  Flex,
  Input,
  MultiSelect,
  SimpleGrid,
  Switch,
  Title,
} from "@mantine/core";
import { uniq } from "lodash";
import { useMemo, useState } from "react";

import { useCompanyOptions } from "../../api/hooks/customer/useCompanyOptions.ts";
import SvgUnfold from "../../components/Icons/Unfold";
import { useStyles } from "./CollectionDashboardPage.styles";
import CustomerPayPastDue from "./CustomerPayPastDue/CustomerPayPastDue.tsx";
import CustomersLongestDPD from "./CustomersLongestDPD/CustomersLongestDPD.tsx";
import CustomersNextDue from "./CustomersNextDue/CustomersNextDue.tsx";
import DashboardStatisticCards from "./DashboardStatisticCards/DashboardStatisticCards.tsx";
import NextMonthDuePerSalesTeam from "./NextMonthDuePerSalesTeam/NextMonthDuePerSalesTeam.tsx";
import NextPaymentDuePerMonth from "./NextPaymentDuePerMonth/NextPaymentDuePerMonth.tsx";
import OutstandingPrincipalAccumulative from "./OutstandingPrincipalAccumulative/OutstandingPrincipalAccumulative.tsx";
import OutstandingPrincipalPerBucket from "./OutstandingPrincipalPerBucket/OutstandingPrincipalPerBucket.tsx";
import { CollectionDashboardFilter } from "./types.ts";

export default function CollectionDashboard() {
  const { classes } = useStyles();

  const [filter, setFilter] = useState<CollectionDashboardFilter>({});

  const [{ data: customersData }] = useCompanyOptions();

  const salesTeamOptions = useMemo(() => {
    return uniq(
      customersData?.customers.data
        ?.map((customer) => customer.salesTeamName || "")
        ?.filter(Boolean)
    );
  }, [customersData?.customers]);

  return (
    <Flex direction="column" gap={{ base: 16, sm: 24 }}>
      <Title>Collection Dashboard</Title>
      <SimpleGrid cols={3} spacing={20} verticalSpacing={8}>
        <MultiSelect
          size="m"
          searchable
          clearable
          multiple
          label="Sales Team"
          placeholder="Select Sales Team"
          data={salesTeamOptions}
          rightSection={<SvgUnfold />}
          value={filter.salesTeam || []}
          onChange={(salesTeam: string[]) => {
            setFilter((prevState) => ({
              ...prevState,
              salesTeam,
            }));
          }}
        />
        <Input.Wrapper label="Restructure">
          <Switch
            variant="yellow"
            checked={!!filter.restructure}
            size="xl"
            onChange={() => {
              setFilter((prevState) => ({
                ...prevState,
                restructure: !prevState.restructure,
              }));
            }}
          />
        </Input.Wrapper>
      </SimpleGrid>

      <DashboardStatisticCards filter={filter} />

      <OutstandingPrincipalPerBucket filter={filter} />

      <OutstandingPrincipalAccumulative filter={filter} />

      <SimpleGrid
        cols={2}
        className={classes.next}
        spacing={20}
        verticalSpacing={16}
      >
        <NextPaymentDuePerMonth filter={filter} />

        <NextMonthDuePerSalesTeam filter={filter} />
      </SimpleGrid>

      <CustomersNextDue filter={filter} />

      <CustomersLongestDPD filter={filter} />

      <CustomerPayPastDue filter={filter} />
    </Flex>
  );
}
